import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreloaderComponent } from './preloader/preloader.component';
import { StatisticsWidgetComponent } from './statistics-widget/statistics-widget.component';
import { CountUpModule } from 'ngx-countup';

@NgModule({
  declarations: [
    PreloaderComponent,
    StatisticsWidgetComponent,
  ],
  imports: [
    CommonModule,
    CountUpModule
  ],
  exports: [
    PreloaderComponent,
    StatisticsWidgetComponent,
  ]
})
export class WidgetModule { }
